<template>
  <div class="wrapper">
    <div
      v-for="c in children"
      :key="c.childId"
    >
      <div class="pa-1 name-wrapper d-flex align-center">
        <div class="icon mr-2">
          <img
            :src="c.imageUrl? c.imageUrl : 'https://via.placeholder.com/240x180?text=Sample+Image+1'"
          >
        </div>
        <h5>{{ c.lastName }}{{ c.firstName }}</h5>
      </div>

      <v-list density="compact">
        <!-- 1. v-list-item-group は廃止、key は template タグに移動 -->
        <template v-for="(item, index) in items" :key="item.title">
          
          <v-list-item
            @click="to( item.path, item.to, c.childId, c.lastName + c.firstName )"
          >
            <!-- 2. v-list-item-content 廃止 → title を直下に配置 -->
            <v-list-item-title v-text="item.title"></v-list-item-title>

            <!-- 3. v-list-item-action 廃止 → append スロットを使用 -->
            <template v-slot:append>
              <div class="d-flex justify-center align-center">
                <p
                  v-if="item?.badgeNum >= 1"
                  class="badge d-flex justify-center align-center mr-2"
                >
                  {{ item.badgeNum ?? 0 }}
                </p>
                <v-icon>mdi-chevron-right</v-icon>
              </div>
            </template>
          </v-list-item>

          <v-divider />
        </template>
      </v-list>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';

import { meModule } from '@/store/entityModules/me';
import { familyModule } from '@/store/entityModules/family';

export default defineComponent({

  computed: {
    children() {
      if (familyModule.family) {
        return familyModule.family.children;
      }
      return [];
    },
  },

  data: () => ({
    items: [
      {
        title: 'チャット',
        badgeNum: 0,
        to: 'Chat',
        path: '/chat',
      },
      {
        title: '今日の記録',
        badgeNum: 0,
        to: 'RecordByDay',
        path: '/record/day',
      },
      {
        title: 'お知らせ一覧/資料室',
        badgeNum: 0,
        to: 'References',
        path: '/references',
      },
      // {
      //   title: 'VEVOレポート',
      //   badgeNum: 0,
      //   to: 'Vevo',
      //   path: '/vevo',
      // },
    ],
  }),

  methods: {
    to(path: string, name: string, childId: string, childName: string) {
      this.$router.push({ name, query: {
        childId,
        childName,
      } });
    },
  },
});
</script>
<style lang="scss" scoped>
.wrapper {
  padding-bottom: 56px;
  @supports (bottom: env(safe-area-inset-bottom)) {
    padding-top: env(safe-area-inset-top);
  }

  .name-wrapper {
    background-color: #F5F6F6;
    .icon {
      height: 40px;
      width: 40px;

      img {
        height: 100%;
        width: 100%;
        border-radius: 100%;
        object-fit: cover;
      }
    }
  }
  .badge {
    height: 23px;
    width: 23px;
    border-radius: 100%;
    font-weight: 500;
    color: #ffffff;
    background-color: rgb(var(--v-theme-primary));
  }
}
</style>
